import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';

interface PromoCategory {
  title: string;
  category: string;
}

interface PromoCategorySelectionProps {
  onSelect: (type: string) => void;
  onClose: () => void;
}

const PromoTypeSelection: React.FC<PromoCategorySelectionProps> = ({ onSelect, onClose }) => {
  const promoTypes: PromoCategory[] = [
    { title: 'Add Order Promo', category: 'ORDER' },
    { title: 'Add Product Promo', category: 'PRODUCT' },
  ];

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle><strong>Select Promo Category</strong></DialogTitle>
      <DialogContent>
        {promoTypes.map((promoCategory, index) => (
          <Button
            variant='outlined'
            style={{marginBottom:10}}
            key={index}
            onClick={() => {
              onSelect(promoCategory.category);
              onClose();
            }}
            fullWidth
          >
            <div className="icon-title-wrapper">
              <AddOutlinedIcon />
              <span className="icon-title">{promoCategory.title}</span>
            </div>
          </Button>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromoTypeSelection;
